<template>
    <div class="testMarking container">
        <el-breadcrumb separator="/" style="margin:24px 0 24px 0">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/personal/room'}">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>阅卷详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <div>
                <div>
                    <el-radio-group v-model.number="examStatus" size="small">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <!-- <el-radio-button :label="0">未通过审核</el-radio-button> -->
                        <!-- <el-radio-button :label="1">审核通过</el-radio-button> -->
                        <el-radio-button :label="1">未交卷</el-radio-button>
                        <!-- <el-radio-button :label="2">已交卷</el-radio-button> -->
                        <el-radio-button :label="3">已阅卷</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <br>
            <el-table tooltip-effect="dark" style="width: 100%" :header-cell-style="{ textAlign:'center' }" :cell-style="{ textAlign: 'center' }" :data="examStudents" @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="ID" prop="id" width="150"></el-table-column>
                <el-table-column label="姓名" prop="nickName" sortable></el-table-column>
                <el-table-column label="学号" prop="username" sortable></el-table-column>
                <el-table-column label="考试状态" prop="status" sortable>
                    <template slot-scope="scope">
                        <el-tag effect="dark" size="mini" :type="scope.row.status === 1 ? 'danger' : scope.row.status === 2 ? '' : 'warning'">
                            {{scope.row.status === 1 ? '未交卷' : scope.row.status === 2 ? '未阅卷' : '已阅卷'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" plain v-if="scope.row.status > 1" :type="scope.row.status === 2 ? 'primary' : 'warning'" @click="lookLook(scope.row)">
                            {{scope.row.status === 2 ? '开始阅卷' : '重新阅卷'}}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <el-pagination background prev-text="上一页" next-text="下一页" layout="total, sizes, prev, pager, next, jumper" :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount" @size-change="handleLimitChange" @current-change="handlePageChange">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
import { getExamStudents } from '@/api/exam/etuserexamhistory'
export default {
    data () {
        return {
            examStatus: -1,
            selections: [],
            page: {
                page: 1, // 当前页
                limit: 10, // 每页条目数
                total: 0,
                pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            },
            examStudents: [
                { id: 1, status: 1, readTeacher: '张三' },
                { id: 2, status: 2, readTeacher: '李四' },
                { id: 3, status: 2 },
                { id: 4, status: 1, readTeacher: '赵六' }
            ]
        };
    },
    watch: {
        examStatus () {
            this.getStudents()
        }
    },
    methods: {
        init () {
            this.getStudents()
        },
        getStudents () {
            let { limit, page } = this.page
            let { id } = this.$route.params
            let approved = this.examStatus
            let params = {
                limit,
                page,
                examId: id
            }
            if (approved > -1) {
                params.approved = approved
            }
            this.examStudents = []
            getExamStudents(params).then(res => {
                let { list, totalCount } = res
                this.$set(this.page, 'total', totalCount)
                this.examStudents = list
            })
        },
        // limit 改变时会触发
        handleLimitChange (limit) {
            this.$set(this.page, 'limit', limit)
            this.getStudents()
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'page', page)
            this.getStudents()
        },
        handleSelectionChange (val) {
            this.selections = val;
        },
        lookLook (exam) {
            let { id, examId } = exam
            this.$router.replace({
                name: 'markingDetails',
                params: { id: examId, recordId: id }
            });
        }
    },
    created () {
        this.init()
    }
};
</script>

<style lang="less" scoped>
.testMarking {
    min-height: 500px;
}
</style>
